import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { useEffect } from 'react';
import Navs from './components/Navs';
import Help from './components/Help';
import Process from './components/Process';
import Slids from './components/Slids';
import Faster from './components/Faster';
import Footer from './components/Footer';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Backtotop from './components/common/Backtotop';
import Preloader from './components/common/Preloader';
import AOS from "aos";
import "aos/dist/aos.css";


function App() {
  useEffect(() => {
    AOS.init({
      once:true,
      duration: 2000
    });
  }, []);

  return (
    <div className='overflow-hidden'>
      <Navs />
      <Help />
      <Process />
      <Slids />
      <Faster />
      <Footer />
      <Backtotop />
      <Preloader />
    </div>
  );
}

export default App;
